const pad = (value: number) => String(value).padStart(2, "0");

const isValidDateParts = (year: number, monthIndex: number, day: number) => {
  const date = new Date(year, monthIndex, day);
  return (
    date.getFullYear() === year &&
    date.getMonth() === monthIndex &&
    date.getDate() === day
  );
};

export const parseDateBR = (value: string): Date | null => {
  if (!value) return null;
  const trimmed = value.trim();
  const brMatch = trimmed.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (brMatch) {
    const day = Number(brMatch[1]);
    const month = Number(brMatch[2]) - 1;
    const year = Number(brMatch[3]);
    if (!isValidDateParts(year, month, day)) {
      return null;
    }
    return new Date(year, month, day);
  }
  const isoMatch = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (isoMatch) {
    const year = Number(isoMatch[1]);
    const month = Number(isoMatch[2]) - 1;
    const day = Number(isoMatch[3]);
    if (!isValidDateParts(year, month, day)) {
      return null;
    }
    return new Date(year, month, day);
  }
  const fallback = new Date(trimmed);
  return Number.isNaN(fallback.getTime()) ? null : fallback;
};

export const isValidDateBR = (value: string): boolean => {
  if (!value || !value.trim()) {
    return false;
  }
  return parseDateBR(value) !== null;
};

export const formatDateBR = (date: Date): string =>
  `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()}`;

export const formatDateInput = (date: Date): string =>
  `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

export const addMonths = (baseDate: Date, delta: number): Date =>
  new Date(baseDate.getFullYear(), baseDate.getMonth() + delta, baseDate.getDate());

export const getMonthRange = (baseDate: Date) => {
  const year = baseDate.getFullYear();
  const month = baseDate.getMonth();
  return {
    from: new Date(year, month, 1),
    to: new Date(year, month + 1, 0),
  };
};

export const getYearRange = (baseDate: Date) => {
  const year = baseDate.getFullYear();
  return {
    from: new Date(year, 0, 1),
    to: new Date(year, 11, 31),
  };
};
